import { ApiBody, ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Logger, Get, UseGuards, Req } from '@nestjs/common';
import { InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError, errorHandler, ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { RawMaterialGrnService } from './raw-material-grn.service';
import { GrnDTO } from './dto/raw-material-grn.dto';

import { AllGrnResponseModel, CreateInvoiceForVoucher, GrnIdReq, GrnResponseModel, InvoiceNumReq, InvoiceStatusReq, InwardFilterReq, LotCodesResponseModel, PayablesDashboardReq, PlantRequest, ReWeighmentInfo, ReweighmentReq, ReWeighMentResponseModel, ReWeighMentViewResponseModel, RmGrnResponseModel, RMInvoicePrintReq, RmInvoiceReq, RmInvoiceUpdateReq, rmReweighmentreq, RMVehicleInfoResponse, TdsApplicableReq, VoucherVendorReq } from '@gtpl/shared-models/raw-material-procurement';
import { GrnRequest } from './dto/raw-material-grn.request';
import { LotCodesRequest } from './dto/lot-codes.request';
import { ReceivedBoxes } from './dto/received-boxes.request';
import { CommonResponse, PlantIdRequest } from '@gtpl/shared-models/masters';
import { SaleOrderDropDownResponseModel } from '@gtpl/shared-models/sale-management';
import { RmGrnDetailsDto } from './dto/rm-grn-details.dto';
import { RmGrnPlantRequest } from './dto/rm-grn-plants-request';
import { RMGrnItemIdReq } from './dto/grn-item-id.request';
import { LotNumberRequest } from './dto/lot-number.request';
import { GrnAbstractRequest } from './dto/grn-abstract.request';
import { PlantsIdRequest } from './dto/plants-id.request';
import { RmActualCountDto } from './dto/rm-actual-count.dto';
import { ErrorResponse, UnitRequest } from '@gtpl/shared-models/common-models';
import { error } from 'console';
import { GrnInvoiceNumberRequest, GrnItemIdRequest } from '@gtpl/shared-models/procurement-management';
import { AverageRateRmReport, LotNoReq, RmInvoiceReportReq, YieldPerReq } from '@gtpl/shared-models/production-management';
import { AntibioticsReq } from './antibiotics-microbiology-report/rm-antibiotics-req';
import { PaybleComponentReq } from '@gtpl/shared-models/analytics-data';

@ApiTags('rm-grn')
@Controller('rm-grn')
export class RawMaterialGrnController {
  constructor(
    private grnService: RawMaterialGrnService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler
  ) { }
  @Post('/createGrn')
  async createGrn(@Body() grnDto: RmGrnDetailsDto, isUpdate: boolean = false): Promise<RmGrnResponseModel> {
    try {
      return await this.grnService.createGrn(grnDto, false);
    } catch (error) {
      console.log(error)
      return this.applicationExceptionHandler.returnException(RmGrnResponseModel, error);
    }
  }
 
  @Post('/updateGrn')
  async updateGrn(@Body() grnDto: RmGrnDetailsDto, @Req() request?: Request): Promise<RmGrnResponseModel> {
    try {
      console.log('update Grn');
      // console.log(request);
      return await this.grnService.createGrn(grnDto, true);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(RmGrnResponseModel, error);
    }
  }
  @Post('/getAllGrn')
  // @UseGuards(AuthGuard('jwt'))
  async getAllGrn(@Body() req:UnitRequest): Promise<CommonResponse> {
    try {
      console.log(req,'ooooo')
      return await this.grnService.getAllGrnData(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  
  @Post('/getAllActiveGrn')
  async getAllActiveGrn(@Req() request: Request): Promise<AllGrnResponseModel> {
    try {
      return await this.grnService.getAllActiveGrn();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllGrnResponseModel, error)
    }
  }
  @Post('/activateOrDeactivateGrn')
  async activateOrDeactivateGrn(@Body() grnreq: GrnRequest): Promise<GrnResponseModel> {
    try {
      return await this.grnService.activateOrDeactivateGrn(grnreq);
    } catch (err) {
      return this.applicationExceptionHandler.returnException(GrnResponseModel, err);
    }
  }
  // @Post('/getGrnById')
  // async getGrnById(@Body() grnreq: GrnRequest): Promise<GrnResponseModel> {
  //   try {
  //     return await this.grnService.getActiveGrnById(grnreq);
  //   } catch (err) {
  //     return this.applicationExceptionHandler.returnException(GrnResponseModel, err);
  //   }
  // }
  @Post('/getLotCodesBySoIdAndSoItemId')
  async getLotCodesBySoIdAndSoItemId(@Body() lotCodesRequest: LotCodesRequest): Promise<LotCodesResponseModel> {
    try {
      return await this.grnService.getLotCodesBySoIdAndSoItemId(lotCodesRequest);
    } catch (err) {
      return this.applicationExceptionHandler.returnException(LotCodesResponseModel, err);
    }
  }

  @Post('/getSaleOrdersHavingLotCodes')
  async getSaleOrdersHavingLotCodes(@Body() plant: PlantsIdRequest): Promise<SaleOrderDropDownResponseModel> {
    try {
      return await this.grnService.getSaleOrdersHavingLotCodes(plant.plantId);
    } catch (err) {
      return this.applicationExceptionHandler.returnException(SaleOrderDropDownResponseModel, err);
    }
  }

  @Post('/assignToRM')
  async assignToRM(@Body() grnDto: any, isUpdate: boolean = false): Promise<CommonResponse> {
    try {
      return await this.grnService.assignToRM(grnDto, false);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  // @Post('/updateReceivedBoxes')
  // async updateReceivedBoxes(@Body() receivedBoxes: ReceivedBoxes): Promise<GrnResponseModel> {
  //   try {
  //     return await this.grnService.updateReceivedBoxes(receivedBoxes);
  //   } catch (error) {
  //     return this.applicationExceptionHandler.returnException(GrnResponseModel, error);
  //   }
  // }
  @Post('/getAllLotCodes')
  async getAllLotCodes(@Body() plant: PlantIdRequest): Promise<LotCodesResponseModel> {
    try {
      return await this.grnService.getAllLotCodes(plant);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(LotCodesResponseModel, error);
    }
  }

  @Post('/getAllSaleOrders')
  async getAllSaleOrders(@Body() plant: PlantIdRequest): Promise<SaleOrderDropDownResponseModel> {
    try {
      return await this.grnService.getAllSaleOrders(plant);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SaleOrderDropDownResponseModel, error);
    }
  }

  @Post('/getRmVehicleGrnById')
  async getRmVehicleGrnById(@Body() grnreq: GrnRequest): Promise<RMVehicleInfoResponse> {
    try {
      return await this.grnService.getRmVehicleGrnById(grnreq);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(RMVehicleInfoResponse, error);
    }
  }

  @Post('/getRmGrnDataById')
  async getGrnDataById(@Body() grnRequest:GrnRequest): Promise<CommonResponse>  {
      try {
          return await this.grnService.getRmGrnDataById(grnRequest);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }

  @Post('/getRmGrnDataByIds')
  async getGrnDataByIds(@Body() grnRequest:GrnRequest): Promise<CommonResponse>  {
      try {
          return await this.grnService.getRmGrnDataByIds(grnRequest);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }

  @Post('getRmGrnfullDataForHarvest')
  async getRmGrnfullDataForHarvest(@Body() req:AntibioticsReq): Promise<CommonResponse> {
    console.log(req,'contr1112222')

      try {
        return await this.grnService.getRmGrnfullDataForHarvest(req);
    } catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  // @Post('getRmGrnfullDataForHarvest')
  // async getRmGrnfullDataForHarvest(): Promise<CommonResponse> {

  //     try {
  //       return await this.grnService.getRmGrnfullDataForHarvest();
  //   } catch (error) {
  //       return this.applicationExceptionHandler.returnException(CommonResponse, error);
  //   }
  // }

  @Post('/updatePlantOrSubPlant')
  async updatePlantOrSubPlant(@Body() grnRequest:RmGrnPlantRequest): Promise<CommonResponse>  {
      try {
          return await this.grnService.updatePlantOrSubPlant(grnRequest);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }

  @Post('/getGrnInfoByItemId')
  async getGrnInfoByItemId(@Body() req:RMGrnItemIdReq): Promise<RMVehicleInfoResponse> {
    try {
      return await this.grnService.getGrnInfoByItemId(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(RMVehicleInfoResponse, error);
    }
  }
  
  @Post('/getTraceabilityCodeForLot')
  async getTraceabilityCodeForLot(@Body() req: LotNumberRequest): Promise<CommonResponse> {
    try {
      return await this.grnService.getTraceabilityCodeForLot(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getGRNAbstract')
  @ApiBody({type:GrnAbstractRequest})
  async getGRNAbstract(@Body() grnAbstractRequest:GrnAbstractRequest ): Promise<AllGrnResponseModel> {
      try {             
         return await this.grnService.getGRNAbstract(grnAbstractRequest);
      } catch (error) {
         return this.applicationExceptionHandler.returnException(AllGrnResponseModel, error);
      }
  } 

  @Post('/getGRNAbstractForReweighment')
  async getGRNAbstractForReweighment(@Body() grnAbstractRequest:GrnAbstractRequest ): Promise<AllGrnResponseModel> {
      try {             
         return await this.grnService.getGRNAbstractForReweighment(grnAbstractRequest);
      } catch (error) {
         return this.applicationExceptionHandler.returnException(AllGrnResponseModel, error);
      }
  } 

  @Post('/updateGrnAuditQty')
  async updateGrnAuditQty(@Body() req:RmActualCountDto): Promise<CommonResponse> {
    try {
      return await this.grnService.updateGrnAuditQty(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getGrnNumberDropdownInfoForRMInvoice')
  async getGrnNumberDropdownInfoForRMInvoice(): Promise<CommonResponse> {
    try {
      return await this.grnService.getGrnNumberDropdownInfoForRMInvoice();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getIndentNumberDropdownInfoForRMInvoice')
  async getIndentNumberDropdownInfoForRMInvoice(): Promise<CommonResponse> {
    try {
      return await this.grnService.getIndentNumberDropdownInfoForRMInvoice();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getGrnItemInfoForInvoice')
  async getGrnItemInfoForInvoice(@Body() req:RmInvoiceReq): Promise<CommonResponse> {
    try {
      return await this.grnService.getGrnItemInfoForInvoice(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/updateInvoiceInfo')
  async updateInvoiceInfo(@Body() req:RmInvoiceUpdateReq): Promise<CommonResponse> {
    try {
      return await this.grnService.updateInvoiceInfo(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/createReweighmentInfo')
  async createReweighmentInfo(@Body() req:ReweighmentReq): Promise<CommonResponse> {
    try {
      return await this.grnService.createReweighmentInfo(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/updateReweighmentStatus')
  async updateReweighmentStatus(@Body() req:GrnIdReq): Promise<CommonResponse> {
    try {
      return await this.grnService.updateReweighmentStatus(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getGrnNumbersDropdownForReweighment')
  async getGrnNumbersDropdownForReweighment(): Promise<CommonResponse> {
    try {
      return await this.grnService.getGrnNumbersDropdownForReweighment();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getGrnInfoForPriceAccpetance')
  async getGrnInfoForPriceAccpetance(@Body() req:InvoiceStatusReq): Promise<CommonResponse> {
    try {
      return await this.grnService.getGrnInfoForPriceAccpetance(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/updateInvoiceStatus')
  async updateInvoiceStatus(@Body() req:GrnIdReq): Promise<CommonResponse> {
    try {
      return await this.grnService.updateInvoiceStatus(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getGrnNumberDropdownForPriceApproval')
  async getGrnNumberDropdownForPriceApproval(@Body() req:InvoiceStatusReq): Promise<CommonResponse> {
    try {
      return await this.grnService.getGrnNumberDropdownForPriceApproval(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getIndentNumberDropdownForPriceApproval')
  async getIndentNumberDropdownForPriceApproval(@Body() req:InvoiceStatusReq): Promise<CommonResponse> {
    try {
      return await this.grnService.getIndentNumberDropdownForPriceApproval(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getRMInvoicePrint')
  async getRMInvoicePrint(@Body() req:RMInvoicePrintReq): Promise<CommonResponse> {
    try {
      return await this.grnService.getRMInvoicePrint(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getGrnWeighInfo')
  async getGrnWeighInfo(@Body() req:ReWeighmentInfo): Promise<ReWeighMentResponseModel> {
    try {
      return await this.grnService.getReWeightMentInfo(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ReWeighMentResponseModel, error);
    }
  }
  
  @Post('/getGrnItemInfoForReweighment')
  async getGrnItemInfoForReweighment(@Body() req:RmInvoiceReq): Promise<ReWeighMentViewResponseModel> {
    try {
      return await this.grnService.getGrnItemInfoForReweighment(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ReWeighMentViewResponseModel, error);
    }
  }
  
  @Post('/getPlantLotNumbers')
  async getPlantLotNumbers(): Promise<CommonResponse> {
    try {
      return await this.grnService.getPlantLotNumbers();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getRefNoInfoAgainstCompany')
  async getRefNoInfoAgainstCompany(@Body() req: RmInvoiceReq): Promise<CommonResponse> {
    try {
      return await this.grnService.getRefNoInfoAgainstCompany(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getReweighmentDetails')
  async getReweighmentDetails(@Body() req: rmReweighmentreq):Promise<CommonResponse>{
    try{
      return await this.grnService.getReweighmentDetails(req);
    }catch(error){
      return this.applicationExceptionHandler.returnException(CommonResponse,error);
    } 
  
}

@Post('/getGrnDropDownDetails')
async getGrnDropDownDetails():Promise<CommonResponse>{
  try{
    return await this.grnService.getGrnDropDownDetails();
  }catch(error){
    return this.applicationExceptionHandler.returnException(CommonResponse,error);
  }
}

@Post('/getFarmerDropDown')
async getFarmerDropDown():Promise<CommonResponse>{
  try{
    return await this.grnService.getFarmerDropDown();
  }catch(error){
    return this.applicationExceptionHandler.returnException(CommonResponse,error);
  }
}
  @Post('/updateReweighmentRemovedCount')
  async updateReweighmentRemovedCount(@Body() req: GrnItemIdRequest): Promise<CommonResponse> {
    try {
      return await this.grnService.updateReweighmentRemovedCount(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getBatchNumberDropdownForInvoice')
  async getBatchNumberDropdownForInvoice(): Promise<CommonResponse> {
    try {
      return await this.grnService.getBatchNumberDropdownForInvoice();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/updateYieldPer')
  async updateYieldPer(@Body() req:YieldPerReq): Promise<CommonResponse> {
    try {
      return await this.grnService.updateYieldPer(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getGrnItemsForRmBudgetReport')
  async getGrnItemsForRmBudgetReport(@Body() req: { month?: number; year?: number }): Promise<CommonResponse> {
    try {
      return await this.grnService.getGrnItemsForRmBudgetReport(req.month, req.year);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getRmInvoiceReport')
  async getRmInvoiceReport(@Body() req:RmInvoiceReportReq): Promise<CommonResponse> {
    try {
      return await this.grnService.getRmInvoiceReport(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getBatchNumbers')
  async getBatchNumbers(): Promise<CommonResponse> {
    try {
      return await this.grnService.getBatchNumbers();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getFarmers')
  async getFarmers(): Promise<CommonResponse> {
    try {
      return await this.grnService.getFarmers();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getCategorys')
  async getCategorys(): Promise<CommonResponse> {
    try {
      return await this.grnService.getCategorys();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getHarvestType')
  async getHarvestType(): Promise<CommonResponse> {
    try {
      return await this.grnService.getHarvestType();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getAverageRateReport')
  async getAverageRateReport(@Body() req?:AverageRateRmReport): Promise<CommonResponse> {
    try {
      return await this.grnService.getAverageRateReport(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getRmInvoiceInfo')
  async getRmInvoiceInfo(@Body() req:InvoiceStatusReq): Promise<CommonResponse> {
    try {
      return await this.grnService.getRmInvoiceInfo(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getRmInvoiceItemsInfo')
  async getRmInvoiceItemsInfo(@Body() req:GrnInvoiceNumberRequest): Promise<CommonResponse> {
    try {
      return await this.grnService.getRmInvoiceItemsInfo(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getProcurementEmployeeNames')
  async getProcurementEmployeeNames(): Promise<CommonResponse> {
    try {
      return await this.grnService.getProcurementEmployeeNames();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }


  @Post('/getAllGrnNUmbers')
  async getAllGrnNUmbers(): Promise<CommonResponse> {
    try {
      return await this.grnService.getAllGrnNUmbers();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  
  @Post('/getAllLotCodesForGrading')
  async getAllLotCodesForGrading(): Promise<CommonResponse> {
    try {
      return await this.grnService.getAllLotCodesForGrading();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getRmGrnDataByLotCode')
  async getRmGrnDataByLotCode(@Body() req:LotNoReq): Promise<CommonResponse>  {
      try {
          return await this.grnService.getRmGrnDataByLotCode(req);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }

  @Post('/getRmGrmFullDataForGrading')
  async getRmGrmFullDataForGrading( @Body() req:AntibioticsReq): Promise<CommonResponse>  {
    try {
        return await this.grnService.getRmGrnFullDataForGrading(req);
    } catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
}

  @Post('/getAddonCountsInfo')
  async getAddonCountsInfo(@Body() req:RmInvoiceReq): Promise<CommonResponse>  {
      try {
          return await this.grnService.getAddonCountsInfo(req);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }

  @Post('/updateRMRatesAgainstIndentDate')
  async updateRMRatesAgainstIndentDate(): Promise<CommonResponse>  {
      try {
          return await this.grnService.updateRMRatesAgainstIndentDate();
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }

  @Post('/getTotalRMPayablesDashboard')
  async getTotalRMPayablesDashboard(@Body() req?:PayablesDashboardReq): Promise<CommonResponse> {
    try {
      return await this.grnService.getTotalRMPayablesDashboard(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

    @Post('/getInvoiceAmountAgainstVendor')
  async getInvoiceAmountAgainstVendor(@Body() req:PaybleComponentReq): Promise<CommonResponse>  {
      try {
          return await this.grnService.getInvoiceAmountAgainstVendor(req);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }

      @Post('/getOverdueInvoiceAmountAgainstVendor')
  async getOverdueInvoiceAmountAgainstVendor(@Body() req:PaybleComponentReq): Promise<CommonResponse>  {
      try {
          return await this.grnService.getOverdueInvoiceAmountAgainstVendor(req);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }

       @Post('/generateTaxableAmountUpdateScript')
  async generateTaxableAmountUpdateScript(@Body() req:TdsApplicableReq): Promise<CommonResponse>  {
      try {
          return await this.grnService.generateTaxableAmountUpdateScript(req);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }
       @Post('/getInwardReport')
  async getInwardReport(@Body() req?:InwardFilterReq): Promise<CommonResponse>  {
      try {
          return await this.grnService.getInwardReport(req);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }

    @Post('/getInwardNo')
  async getInwardNo(): Promise<CommonResponse> {
    try {
      return await this.grnService.getInwardNo();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

    @Post('/getInwardType')
  async getInwardType(): Promise<CommonResponse> {
    try {
      return await this.grnService.getInwardType();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

    @Post('/getInwardFarmers')
  async getInwardFarmers(): Promise<CommonResponse> {
    try {
      return await this.grnService.getInwardFarmers();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

    @Post('/getInwardProducts')
  async getInwardProducts(): Promise<CommonResponse> {
    try {
      return await this.grnService.getInwardProducts();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

    @Post('/getInwardVouchers')
  async getInwardVouchers(): Promise<CommonResponse> {
    try {
      return await this.grnService.getInwardVouchers();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

      @Post('/getVendorsForInvoice')
  async getVendorsForInvoice(): Promise<CommonResponse> {
    try {
      return await this.grnService.getVendorsForInvoice();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

         @Post('/getVouchersAgainstFarmerForFinance')
  async getVouchersAgainstFarmerForFinance(@Body() req:VoucherVendorReq): Promise<CommonResponse>  {
      try {
          return await this.grnService.getVouchersAgainstFarmerForFinance(req);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }

    @Post('/getInvoiceDetails')
  async getInvoiceDetails(@Body() req:InvoiceNumReq): Promise<CommonResponse>  {
      try {
          return await this.grnService.getInvoiceDetails(req);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }
    @Post('/getAllInvoiceNumbers')
  async getAllInvoiceNumbers(): Promise<CommonResponse>  {
      try {
          return await this.grnService.getAllInvoiceNumbers();
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }

           @Post('/createInvoiceAgainstVoucher')
  async createInvoiceAgainstVoucher(@Body() req:CreateInvoiceForVoucher): Promise<CommonResponse>  {
      try {
          return await this.grnService.createInvoiceAgainstVoucher(req);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }

}
